/**
 * CustomerPrivacyApp created to handle privacy related functionality.
 */

// only the init if the customer privacy page is being displayed.
if (WebPageObj.customerPrivacyRequestVerification) {
    $(() => {
        CustomerPrivacyRequestVerificationApp.init();
    });
}

/**
 * Obj to handle the app code.
 *
 * @returns obj
 *
 * @constructor
 */
window.CustomerPrivacyRequestVerificationApp = function() {
    const verificationFeedbackPanel = $(".hiddenFeedbackPanel");
    const sendVerificationRequestBtn = $("#sendVerificationRequestBtn");
    const firstNameInput = $("#firstName");
    const lastNameInput = $("#lastName");
    const emailInput = $("#customerEmail");

    const generalFailureError = "An unexpected error has occurred. Please try again or submit an inquiry to privacy@avasflowers.com, if the problem persists.";

    return {
        /**
         * Initialize the application
         */
        init: function() {
            // When the verify request button is clicked
            sendVerificationRequestBtn.on("click", (e) => {
                e.preventDefault();
                this.handleRequestForm();
            });
        },

        /**
         * Handle the request verification form submission
         */
        handleRequestForm: function() {
            const originalBtnText = sendVerificationRequestBtn.val();
            const waitMsg = "Please Wait...";

            // Do not proceed if an existing call is being processed
            if (sendVerificationRequestBtn.val() === waitMsg) return;

            // Update submit button
            sendVerificationRequestBtn.val(waitMsg);

            // Hide the feedback panel
            hideFeedbackPanel(verificationFeedbackPanel);

            $.ajax({
                url: "/api/cs_privacy/send_request_verification",
                method: "POST",
                data: {
                    firstName: firstNameInput.val(),
                    lastName: lastNameInput.val(),
                    email: emailInput.val()
                },
                dataType: "json",
                success: (data) => {
                    if (data.status) {
                        // Clear form inputs on success
                        firstNameInput.val("");
                        lastNameInput.val("");
                        emailInput.val("");
                        
                        this.displayVerificationFeedbackPanel('success', data.message);
                    } else {
                        const panelType = data.showInfoBox ? 'info' : 'error';
                        this.displayVerificationFeedbackPanel(panelType, data.message);
                    }
                    
                    // Restore button text
                    sendVerificationRequestBtn.val(originalBtnText);
                },
                error: () => {
                    this.displayVerificationFeedbackPanel('error', generalFailureError);
                    
                    // Restore button text
                    sendVerificationRequestBtn.val(originalBtnText);
                }
            });
        },

        /**
         * Display the feedback panel
         * @param {string} type - The type of feedback: error, success, info
         * @param {string} message - The message to display
         */
        displayVerificationFeedbackPanel: function(type, message) {
            // Panel settings
            const panelSettings = {
                default: {panelClass: 'panel-default', panelHeading: "See below message."},
                error: {panelClass: 'panel-danger', panelHeading: "Error!"},
                info: {panelClass: 'panel-info', panelHeading: "Info!"},
                success: {
                    panelClass: 'panel-success',
                    panelHeading: "Please follow the instructions below to proceed."
                },
            };

            displayFeedbackPanel(panelSettings, verificationFeedbackPanel, type, message);
        }
    };
}();